import React from 'react';
import Row from 'components/Common/Row';
import ActiveFilterToggle from '../ActiveFilterTogle';
import LoadingSearch from '../LoadingSearch';
import ContentResults from './ContentResults';
import EntityResults from './EntityResults';

const SearchResultsContainer = ({
  searchText,
  contentGroups,
  onContentNavigate,
  hasEntities,
  isLoadingEntities,
  results,
  onEntityNavigate,
  setSelectedEntity,
  isActiveFilterDisabled,
  setIsActiveFilterDisabled,
}: {
  searchText: string;
  contentGroups: GlobalSearch.ContentResultGroup[];
  onContentNavigate: (result: GlobalSearch.ContentResult) => void;
  hasEntities: boolean;
  isLoadingEntities: boolean;
  results: GlobalSearch.SearchResults;
  onEntityNavigate: (entity: EntityDetails.Entity) => void;
  setSelectedEntity: React.Dispatch<
    React.SetStateAction<EntityDetails.Entity | undefined>
  >;
  isActiveFilterDisabled: boolean;
  setIsActiveFilterDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <div>
      <div style={{ padding: '16px 24px' }}>
        <Row centerAlign spaceBetween>
          <div
            style={{
              color: 'var(--color-text-muted)',
              fontStyle: 'italic',
              fontSize: 14,
            }}
          >
            {`Showing results for "${searchText}"`}
          </div>
          {hasEntities && (
            <ActiveFilterToggle
              isActiveFilterDisabled={isActiveFilterDisabled}
              setIsActiveFilterDisabled={setIsActiveFilterDisabled}
            />
          )}
        </Row>
      </div>

      <ContentResults
        groups={contentGroups}
        searchText={searchText.trim()}
        onContentNavigate={onContentNavigate}
      />

      {hasEntities && isLoadingEntities && <LoadingSearch />}
      {hasEntities &&
        !isLoadingEntities &&
        results.results.map((result) => (
          <EntityResults
            key={result.entity.id}
            result={result}
            onEntityNavigate={onEntityNavigate}
            isShowingFirstFour={true}
            setSelectedEntity={setSelectedEntity}
          />
        ))}
    </div>
  );
};

export default SearchResultsContainer;
